import { useState } from 'react';
import cn from 'classnames';
import Overview from './overview';
import Paid from './paid';
import Orders from './orders';
import styles from '../salonAccount.module.scss';

const Tabs = ({ salon, global, locale }) => {
  const [selectedTab, setSelectedTab] = useState(0);

  const tabs = [
    { title: global.account['salonAccount-Overview']?.text, index: 0 },
    { title: global.payments['paymentsTable-Title']?.text, index: 1 },
    { title: global.orders['ordersTable-Title']?.text, index: 2 },
  ];

  const showSelectedTab = tab => {
    switch (tab.index) {
      case 0:
        return (
          <Overview salon={salon} setSelectedTab={setSelectedTab} global={global} locale={locale} />
        );
      case 1:
        return <Paid salon={salon} global={global} locale={locale} />;
      case 2:
        return <Orders salon={salon} global={global} locale={locale} />;
      default:
        return 'No Tab Selected';
    }
  };

  return (
    <div className={cn(styles.tabs)}>
      <div className={styles.tabHeader}>
        <div className={styles.tabButtons}>
          {tabs.map(tab => (
            <div
              className={cn(styles.tabButton, { [styles.selected]: tab.index === selectedTab })}
              onClick={() => setSelectedTab(tab.index)}
              onKeyDown={() => setSelectedTab(tab.index)}
              tabIndex={tab.index}
              role="button"
            >
              {tab.title}
            </div>
          ))}
        </div>
      </div>
      {tabs.map(tab => (
        <div className={cn(styles.tabContent, { [styles.visible]: tab.index === selectedTab })}>
          {showSelectedTab(tab)}
        </div>
      ))}
    </div>
  );
};

export default Tabs;
